import BannerProps from './Banner.props'
import * as S from './style'

export default function Banner ({ children }: BannerProps): JSX.Element {
  return <S.Banner>{children}</S.Banner>
}
